import $ from "jquery";

export const Login = function () {
	if (!($("#login").length > 0)) return false;

	const $elms = {
		form: $("#login-form"),
		username: $("#username"),
		password: $("#password"),
		submitButton: $(".js-login"),
		passwordNote: $(".js-password-false"),
		forgotPassword: $(".js-forgot-password"),
		forgotPasswordPopup: $(".js-forgot-password-popup"),
		forgotPasswordPopupClose: $(".js-forgot-password-popup-close"),
		passwordToggle: $(".js-password-toggle"),
	};

	const validateForm = () => {
		const username = $elms.username.val().trim();
		const password = $elms.password.val().trim();

		const isValid = username && password;
		$elms.submitButton.prop("disabled", !isValid);
		return isValid;
	};

	// Initial validation
	validateForm();

	// Add input event listeners for real-time validation
	$elms.username.on("input", validateForm);
	$elms.password.on("input", validateForm);

	$elms.form.on("submit", function (e) {
		e.preventDefault();

		if (!validateForm()) {
			return;
		}

		$elms.form.removeClass("is-password-false");

		const username = $elms.username.val().trim();
		const password = $elms.password.val().trim();

		// Disable button during submission
		$elms.submitButton.prop("disabled", true);
		$elms.submitButton.addClass("is-loading");

		$.ajax({
			url: window.CFG.ajaxUrl,
			type: "POST",
			data: {
				action: "login",
				nonce: window.CFG.nonce,
				username,
				password,
			},
			success: function (response) {
				if (response.success) {
					// Redirect on success
					window.location.href = response.data?.redirect || window.CFG.siteURL;
				} else {
					// Show error message
					// alert(response.data?.message || (window.CFG.strings?.authLogin?.login_failed_text || "Login failed. Please try again."));
					$elms.passwordNote.html(
						response.data?.message || (window.CFG.strings?.authLogin?.login_failed_text || "Login failed. Please try again."),
					);
					$elms.form.addClass("is-password-false");
					setTimeout(() => {
						$elms.form.removeClass("is-password-false");
					}, 3000);
				}
			},
			error: function (error) {
				console.error(error);
				// alert((window.CFG.strings?.authLogin?.login_failed_text || "Login failed. Please try again."));
				$elms.passwordNote.html((window.CFG.strings?.authLogin?.login_failed_text || "Login failed. Please try again."));
				$elms.form.addClass("is-password-false");
				setTimeout(() => {
					$elms.form.removeClass("is-password-false");
				}, 3000);
			},
			complete: function () {
				// Re-enable button after completion
				$elms.submitButton.prop("disabled", false);
				$elms.submitButton.removeClass("is-loading");
			},
		});
	});

	const $resetForm = $("#forgot-password-form");
	const $resetButton = $(".js-request-password-reset");
	const $resetMessage = $(".js-reset-password-message");
	const $resetEmail = $("#reset-email");
	const $resetControls = $elms.forgotPasswordPopup.find("button, input");
	let closeTimer = null;
	let resetComplete = false;

	const closeResetPopup = () => {
		clearTimeout(closeTimer);
		$elms.forgotPasswordPopup.attr("inert", "").removeClass("is-active");
		$elms.forgotPassword.trigger("focus");
	};

	$elms.forgotPassword.on("click", function (e) {
		e.preventDefault();
		clearTimeout(closeTimer);
		$resetForm[0].reset();
		$resetMessage.empty();
		$resetControls.prop("disabled", false);
		resetComplete = false;
		$elms.forgotPasswordPopup.removeAttr("inert").addClass("is-active");
		$resetEmail.trigger("focus");
	});

	$elms.forgotPasswordPopupClose.on("click", function (e) {
		e.preventDefault();
		if ($(this).prop("disabled")) return;
		closeResetPopup();
	});

	$resetForm.on("submit", function (e) {
		e.preventDefault();
		if ($resetButton.prop("disabled")) return;
		const email = $resetEmail.val().trim();
		$resetControls.prop("disabled", true);
		$resetMessage.text(window.CFG.strings?.authLogin?.reset_processing_text || "Je verzoek wordt verwerkt…");
		$.ajax({
			url: window.CFG.ajaxUrl,
			type: "POST",
			data: {
				action: "request_password_reset",
				nonce: window.CFG.nonce,
				email,
			},
			success: function (response) {
				$resetMessage.text(response.data?.message || (window.CFG.strings?.authLogin?.reset_failed_text || "Het versturen is niet gelukt. Probeer het opnieuw."));
				if (response.success) {
					resetComplete = true;
					const seconds = Number(window.CFG.passwordReset?.success_close_seconds) || 3;
					closeTimer = setTimeout(closeResetPopup, seconds * 1000);
				}
			},
			error: function () {
				$resetMessage.text(window.CFG.strings?.authLogin?.reset_connection_error_text || "Het versturen is niet gelukt. Controleer je verbinding en probeer het opnieuw.");
			},
			complete: function () {
				if (!resetComplete) $resetControls.prop("disabled", false);
			},
		});
	});

	$elms.passwordToggle.on("click", function () {
		const $this = $(this);
		const $input = $this.siblings(".input-text");
		const type = $input.attr("type");
		$input.attr("type", type === "password" ? "text" : "password");
		$this.toggleClass("is-password-false");
	});
};
